module.exports = __webpack_public_path__ + "img/图片12.323ff9ba.png";